/** @format */

import {format, parseISO, startOfDay, subDays} from 'date-fns';

import {Period} from '../types';

/**
 * Правила:
 * - Если endOn отсутствует → endOn = вчера.
 * - Если endOn есть → не позже вчера (clamp к вчерашнему дню, если дата в будущем).
 * - Если после этого startOn > endOn → startOn = endOn.
 * Возвращает обе даты в формате 'yyyy-MM-dd'.
 */

interface Options {
  startOn: string;
  endOn?: string | null;
  today: Date;
}

const getCurrentMediaplanPeriod = ({startOn, today, endOn}: Options): Period => {
  const day = startOfDay(today);
  const yesterday = subDays(day, 1);

  const start = startOfDay(parseISO(startOn));
  const rawEnd = endOn ? startOfDay(parseISO(endOn)) : undefined;

  // endOn: максимум — вчера
  const end = !rawEnd || rawEnd > yesterday ? yesterday : rawEnd;

  // Если startOn оказался позже endOn — поджимаем к end
  const clampedStart = start > end ? end : start;

  return {
    startDate: format(clampedStart, 'yyyy-MM-dd'),
    endDate: format(end, 'yyyy-MM-dd'),
  };
};

export {getCurrentMediaplanPeriod};
